// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/variables.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/anchor.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__container___YuErL a {
    position: relative;
    padding-right: 30px;
    font-size: var(--title-font-size-mobile);
    color: var(--text);
    text-decoration: none;
}
.styles__container___YuErL a::before {
    position: absolute;
    top: 50%;
    right: 0;
    display: block;
    width: 18px;
    height: 18px;
    content: "";
    opacity: 0;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center/contain;
    transform: translateY(-50%);
    transition: opacity .2s;
}
.styles__container___YuErL a:hover::before,
.styles__container___YuErL a:focus::before {
    opacity: 1;
}

@media screen and (min-width: 768px) {
    .styles__container___YuErL a {
        font-size: var(--title-font-size-desktop);
    }
}
`, "",{"version":3,"sources":["webpack://./../../shared/components/Anchor/styles.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX,UAAU;IACV,4EAAiE;IACjE,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;;IAEI,UAAU;AACd;;AAEA;IACI;QACI,yCAAyC;IAC7C;AACJ","sourcesContent":["@import \"../../styles/variables.css\";\n\n.container a {\n    position: relative;\n    padding-right: 30px;\n    font-size: var(--title-font-size-mobile);\n    color: var(--text);\n    text-decoration: none;\n}\n.container a::before {\n    position: absolute;\n    top: 50%;\n    right: 0;\n    display: block;\n    width: 18px;\n    height: 18px;\n    content: \"\";\n    opacity: 0;\n    background: url(../../assets/anchor.png) no-repeat center/contain;\n    transform: translateY(-50%);\n    transition: opacity .2s;\n}\n.container a:hover::before,\n.container a:focus::before {\n    opacity: 1;\n}\n\n@media screen and (min-width: 768px) {\n    .container a {\n        font-size: var(--title-font-size-desktop);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles__container___YuErL`
};
export default ___CSS_LOADER_EXPORT___;
